<!-- eslint-disable -->
<template>
	<div> 
		<qrcode-vue :value="value" :size="size" level="H" v-if="isBase64 == false" />
		<img v-else :width="size" :height="size" :src="value" alt="qrcode" />
	</div>
</template>
<script>
	/* eslint-disable */
  import QrcodeVue from 'qrcode.vue'
  export default {
		props : {
			value: {
				type: String,
				default: ""
			},
			isBase64: {
				type: Boolean,
				default: false
			},
		},
    data() {
      return {
        size: 300,
      }
    },
    components: {
      QrcodeVue,
    },
  }
</script>